export default __webpack_public_path__ + "static/media/Order.bce1002b.png";